module.exports = __webpack_public_path__ + "img/PriceQuotationAffiliateOperations.e0fe28ed.svg";